export const SET_NOTIF = 'redux/notif/SET_NOTIF';
export const CLEAR_NOTIF = 'redux/notif/CLEAR_NOTIF';